import {Injectable} from '@angular/core';
import {BaseApiService} from "../../shared/base/base-api.service";

@Injectable({
  providedIn: 'root'
})
export class LookupService extends BaseApiService {

  getAccountTypes() {
    return this.fromFile('assets/json/account-type.json');
  }

  getCarrierType() {
    return this.fromFile('assets/json/carrier-type.json');
  }
}
